module.exports = __webpack_public_path__ + "images/category_lp/common/form-btn-sp@2x_70037c94bc945811918219c39ab98cf1.png";